import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    width: "100%"
  },
  fileInfo: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flex: 1,
    minWidth: 0,
  },
  iconWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 31,
    height: 31,
    borderRadius: "50%",
    flexShrink: 0,
  },
  glyph: {
    width: 16,
    height: 16,
    objectFit: "contain",
    filter: "brightness(0) invert(1)",
    transform: "scaleY(-1)",
  },
  text: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    lineHeight: 1.2,
  },
  name: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 14,
    color: "#2A3333",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  size: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 10,
    color: "#6C7A7A",
    marginTop: 2,
  },
  nameLink: {
    textDecoration: "underline",
  },
  deleteBtn: {
    flexShrink: 0,
    color: "#6C7A7A",
    padding: 4,
  },
  downloadLink: {
    display: "inline-flex",
    width: 24,
    height: 24,
    flexShrink: 0,
  },
  download: {
    cursor: "pointer",
    width: 24,
    height: 24,
    display: "block",
  },
}));
